import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  data: {},
  loading: false,
})

const { Types, Creators } = createActions({
  getDeliveryFeeOffers: null,

  setLoading: ['val'],
  setDeliveryFeeOffers: ['data'],
  setDeliveryFeeOffer: ['deliveryFeeOfferId', 'data'],

  deleteDeliveryFeeOffer: ['deliveryFeeOffer'],
  saveDeliveryFeeOffer: ['data', 'deliveryFeeOffer'],
})

export const setDeliveryFeeOffersReducer = (state, {data}) => state.set('data', data)

export const setDeliveryFeeOfferReducer = (state, { deliveryFeeOfferId, data }) =>
  state.setIn(['data', deliveryFeeOfferId], data)

export const setLoadingReducer = (state, { val }) => state.set('loading', val)

export const deleteDeliveryFeeOfferReducer = (state, { deliveryFeeOffer }) =>
  state.set('data', state.data.without(deliveryFeeOffer.key))

export const deliveryFeeOfferReducer = createReducer(INITIAL_STATE, {
  [Types.SET_LOADING]: setLoadingReducer,
  [Types.SET_DELIVERY_FEE_OFFER]: setDeliveryFeeOfferReducer,
  [Types.SET_DELIVERY_FEE_OFFERS]: setDeliveryFeeOffersReducer,
  [Types.DELETE_DELIVERY_FEE_OFFER]: deleteDeliveryFeeOfferReducer,
})

export const DeliveryFeeOfferTypes = Types
export default Creators


// WEBPACK FOOTER //
// ./src/reducers/deliveryFeeOfferReducer.js